module.exports = __webpack_public_path__ + "img/RemoveUser.b244a4f0.svg";